import React from "react";

export const CheckMark = () => (
    <svg width="14" height="14" viewBox="0 0 74 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 28.3381L25.004 48.3421L68.3462 5" stroke="white" stroke-width="10" stroke-linecap="round"/>
    </svg>
);
